import { UserSearch } from "../types/users.types";

export const getUsersFormatter = (params: UserSearch.Request): string => {
  const queryParams = new URLSearchParams();

  queryParams.append("limit", String(params.limit));
  queryParams.append("offset", String(params.offset * params.limit));

  if (params.searchValue) queryParams.append("name", params.searchValue);
  if (params.countryId) queryParams.append("countryId", params.countryId);
  if (params.nationalityId) queryParams.append("nationalityId", params.nationalityId);
  if (params.gender) queryParams.append("gender", params.gender);
  if (params.verificationStatus) queryParams.append("verificationStatus", params.verificationStatus);
  if (params.role) queryParams.append("role", params.role.toUpperCase());
  if (params.trending) queryParams.append("trendingStatus", "TRENDING_THIS_MONTH");
  if (params.isFollowing) queryParams.append("isFollowing", String(params.isFollowing));

  const queryString = queryParams.toString();
  return queryString ? `?${queryString}` : "";
};
